

import { post, get, put } from 'lib/API';

export const getAllServices = async (
  queryParams: string,
  token: any
) => {
  return await get(`v1/personalServices?${queryParams}`, token);
}

export const getService = async (
  [serviceId]: any[],
  { token }: any
) => {
  return await get(`v1/personalServices/${serviceId}`, token);
}

export const createService = async (
  [service]: any,
  { token }: any
) => {
  return await post('v1/personalServices', token, service);
}

export const deleteServices = async (
  [serviceIds]: any,
  { token }: any
) => {
  return await put(`v1/personalServices/bulk/delete`, token, { serviceIds });
}

export const updateService = async (
  [service]: any,
  { token }: any
) => {
  return await put(`v1/personalServices/${service.id}`, token, service);
}

export const importServiceProducts = async (
  [vendorId, data]: any,
  { token }: any
) => {
  return await post(`v1/personalServices/import/${vendorId}`, token, data);
}

export const getExportProductAddons = async (
  [serviceId, vendorId]: any,
  { token }: any
) => {
  return await get(`v1/personalServices/productAddonsExport/${serviceId}/${vendorId}`, token);
}